import { Injectable } from '@angular/core';
import { UserService } from './user.service';
import { ApiService } from './api.service';
import { JwtHelper } from 'angular2-jwt';

@Injectable()
export class AuthInterceptor {
    refreshingToken: boolean = false;
    private jwtHelper: JwtHelper = new JwtHelper();
    constructor(private userService: UserService, private apiService: ApiService ) { }

    intercept(): void {
        if(this.refreshingToken == true)
            return;
        const accessToken = this.userService.getToken();
        if (!accessToken) {
            return;
        }
        if (accessToken && this.isValidToken(accessToken) && this.isAboutExpire(accessToken)) {
            this.refreshingToken = true;
            const refreshToken = this.userService.getRefreshToken() || '';
            this.userService.clearCurrentSession();
            this.apiService.refreshToken(refreshToken).subscribe(
                (session: any) => {
                    this.refreshingToken = false
                    this.userService.saveCurrentSession(session);
                    this.userService.saveToken(JSON.parse(session._body).body.access_token)
                },
                (error) => {
                    this.refreshingToken = false
                }
            );
        }
    }
    //check if the token is about to exprie in 30seconds
    isAboutExpire(token: string): boolean{
        let timeToExpireMillie = this.jwtHelper.getTokenExpirationDate(token).getTime() - new Date().getTime();
        return timeToExpireMillie <= 30000 && timeToExpireMillie > 0;
    }

    isValidToken(token): boolean{
        try{
            let str = this.jwtHelper.decodeToken(token);
            return true;
        }
        catch{
            return false;
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/services/auth.interceptor.ts